import { useTranslation } from 'react-i18next';
import { FormProvider } from 'react-hook-form';
import { StepPageWrapper } from '@Layout/StepPageWrapper.tsx';

import { worldCountires } from '../../../hooks/worldCountries';
import { useAdditionalLocationsLogic } from './hooks/useAdditionalLocationsLogic';
import { AdditionalBusinessLocations } from './AdditionalBusinessLocations';

export const EddAdditionalBusinessLocations = () => {
  const { t } = useTranslation('eddQuestions');
  const { t: tCommon } = useTranslation();
  const {
    handleSubmit,
    formMethods,
    countries,
    fields,
    append,
    prepend,
    remove,
    hasAdditionalLocations,
    isPostingEddData,
    clearErrors,
    trigger,
    reset,
  } = useAdditionalLocationsLogic(worldCountires);

  return (
    <FormProvider {...formMethods}>
      <StepPageWrapper
        isLoading={isPostingEddData}
        formMethods={formMethods}
        handleSubmit={handleSubmit}
        heading={tCommon('sectionTitles.businessDetails')}
        content={t('organic.additionalLocations.title')}
        text={t('organic.additionalLocations.question')}
        textCustomStyle='mt-[24px] text-text-main-primary text-[16px]'
        headingContainerCustomStyle='!mb-[16px]'>
        <AdditionalBusinessLocations
          remove={remove}
          countries={countries}
          fields={fields}
          append={append}
          prepend={prepend}
          hasAdditionalLocations={hasAdditionalLocations}
          clearErrors={clearErrors}
          trigger={trigger}
          reset={reset}
        />
      </StepPageWrapper>
    </FormProvider>
  );
};
